"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _immer = _interopRequireDefault(require("immer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Table) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(_class, _React$Component);

    function _class(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.state = {
        columns: props.columns,
        delta: 0
      };
      return _this;
    }

    var _proto = _class.prototype;

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var _this2 = this;

      var prevColumns = prevProps.columns;
      var columns = this.props.columns;

      if (prevColumns !== columns) {
        if (prevColumns.length !== columns.length) {
          this.setState({
            columns: columns
          });
        } else {
          var widthed = (0, _immer.default)(columns, function (draft) {
            draft.forEach(function (column, index) {
              column.width = _this2.state.columns[index].width;
            });
          });
          this.setState({
            columns: widthed
          });
        }
      }
    };

    _proto.getWidth = function getWidth() {
      var width = this.props.width;
      if (typeof width === 'number') return width + this.state.delta;
      return width;
    };

    _proto.handleResize = function handleResize(index, width, colgroup) {
      var onColumnResize = this.props.onColumnResize;
      var changed = (0, _immer.default)(this.state, function (draft) {
        var column = draft.columns[index];
        draft.delta += parseFloat(width - (column.width || 0));
        colgroup[index] = width;
        draft.columns.forEach(function (col, i) {
          var w = colgroup[i];
          if (w) col.width = w;
        });
      });

      if (onColumnResize) {
        onColumnResize(changed.columns);
        return;
      }

      this.setState(changed);
    };

    _proto.render = function render() {
      var columns = this.state.columns;

      var _this$props = this.props,
          onColumnResize = _this$props.onColumnResize,
          other = _objectWithoutPropertiesLoose(_this$props, ["onColumnResize"]);

      var width = this.getWidth();
      return _react.default.createElement(Table, _extends({}, other, {
        width: width,
        columns: columns,
        onResize: this.handleResize
      }));
    };

    return _class;
  }(_react.default.Component), _defineProperty(_class, "propTypes", {
    columns: _propTypes.default.array.isRequired,
    onColumnResize: _propTypes.default.func,
    width: _propTypes.default.number
  }), _temp;
};

exports.default = _default;